import * as React from 'react';

import { AnalyticsStore } from 'bernie-core';
import { formatText } from 'bernie-l10n';

import { RatePlanViewModel, RoomViewModel } from 'models';

import { UitkExpandoLink, UitkExpandoLinkTypeSize } from 'uitk-react-expando';

import { RoomRateOptions } from 'components/infosite/rooms-and-rates/room-rate-options';

export interface RoomRateExpandableOptionsProps {
  id: string;
  isUnavailable?: boolean;
  position: string;
  excludeReserveButton?: boolean;
  ratePlanCollection?: RatePlanViewModel[];
  room: RoomViewModel;
  trackingRfrr?: string;
  isPinnedRatePlan?: boolean;
  type?: string;
  analytics: AnalyticsStore;
}

export interface RoomRateExpandableOptionsState {
  titleText: string;
  rffrId: string;
}

const MINIMUM_NUMBER_OF_VISIBLE_RATE_PLANS = 2;

export class RoomRateExpandableOptions extends React.Component<RoomRateExpandableOptionsProps, RoomRateExpandableOptionsState> {
  constructor(props) {
    super(props);
    this.state = {
      titleText: this.props.room.expandRatePlansLabel || formatText('contentToggle.expand.label'),
      rffrId: 'Expand',
    };

    this.handleLinkClick = this.handleLinkClick.bind(this);
    this.prioritizeRatePlans = this.prioritizeRatePlans.bind(this);
  }

  private handleLinkClick(isOpen) {
    const { room, analytics, position } = this.props;
    const expandRatePlansLabel = room.expandRatePlansLabel || formatText('contentToggle.expand.label');
    this.setState({
      titleText: isOpen ? formatText('contentToggle.collapse.label') : expandRatePlansLabel,
      rffrId: isOpen ? 'Collapse' : 'Expand',
    });

    if (analytics && typeof analytics.trackEvent === 'function') {
      analytics.trackEvent(`.RatePlan.${this.state.rffrId}.Room${position}`, this.state.rffrId, null, null, true);
    }
  }

  private prioritizeRatePlans(ratePlanList: RatePlanViewModel[], optionBaseIndex: number = 0) {
    const { excludeReserveButton, id, isUnavailable, position, room, trackingRfrr, isPinnedRatePlan } = this.props;

    return (
      <RoomRateOptions
        id={id}
        position={position}
        ratePlanCollection={ratePlanList}
        room={room}
        excludeReserveButton={excludeReserveButton}
        isPinnedRatePlan={isPinnedRatePlan}
        isUnavailable={isUnavailable}
        trackingRfrr={trackingRfrr}
        optionBaseIndex={optionBaseIndex}
      />
    );
  }

  public render() {
    const { ratePlanCollection } = this.props;

    if (!ratePlanCollection || ratePlanCollection.length === 0) {
      return null;
    }

    const { titleText } = this.state;
    const visiblePlans = ratePlanCollection.slice(0, MINIMUM_NUMBER_OF_VISIBLE_RATE_PLANS);
    const hiddenPlans = ratePlanCollection.slice(MINIMUM_NUMBER_OF_VISIBLE_RATE_PLANS);

    return (
      <>
        {this.prioritizeRatePlans(visiblePlans)}
        {hiddenPlans && hiddenPlans.length > 0 && (
          <div className="uitk-cell">
            <UitkExpandoLink
              type={UitkExpandoLinkTypeSize.TYPE_200}
              expandoTitle={titleText}
              isVisible={false}
              onDetailsToggle={this.handleLinkClick}
              className="all-l-padding-three"
            >
              {this.prioritizeRatePlans(hiddenPlans, MINIMUM_NUMBER_OF_VISIBLE_RATE_PLANS)}
            </UitkExpandoLink>
          </div>
        )}
      </>
    );
  }
}
